export { default as TestResultDetailsPage } from "./testResultDetails";
